import { Flex } from "@chakra-ui/react";
import { FC } from "react";

import { DashboardIcon, hasRanaTenant, retrieveTenantAndOrganisation } from "@nens/ranalib";

const DashboardLink: FC = () => {
  const ranaLink = hasRanaTenant() ? `/${retrieveTenantAndOrganisation().tenant}/` : "/";

  return (
    <button
      style={{
        // Buttonlink
        background: "none",
        border: "none",
        padding: 0,
        font: "inherit",
        cursor: "pointer",

        maxWidth: "250px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "1.25em",
      }}
      title="Rana dashboard"
      onClick={() => (window.location.href = ranaLink)}
    >
      <Flex alignItems="center">
        <DashboardIcon boxSize={7} mr={1} />
        Rana dashboard
      </Flex>
    </button>
  );
};

export default DashboardLink;
